import { ref } from "vue";
import { isCompactMode } from "@/data/pubilc";

const defaultValue = !isCompactMode.value;

const isExpand = ref(defaultValue);

export { isExpand };
